<!--Options-->
<div class="OptionsBorder">
	<h4 style="text-align: center">Options:</h4>

	<div class="OptionsInnerDiv">
		<label>School</label>
		<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText"> </caass-schoolselector>

		<label>Date Range:</label>
		<div class="RadDiv">
			<input class="RAD" type="radio" id="All" [value]="true" name="AllDates" [(ngModel)]="AllDates" />
			<label for="All">All</label>

			<input class="RAD" type="radio" id="SelectRange" [value]="false" name="AllDates" [(ngModel)]="AllDates" />
			<label for="SelectRange">Select Range</label>
		</div>

		<label *ngIf="AllDates == false">Start Date:</label>
		<p-calendar *ngIf="AllDates == false" showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate" appendTo="body"></p-calendar>

		<label *ngIf="AllDates == false">End Date:</label>
		<p-calendar *ngIf="AllDates == false" showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate" appendTo="body"></p-calendar>
	</div>
</div>

<!--Block Alert Table-->
<div>
	<caass-station-block-alert-table
		[SelectedSchool]="SelectedSchool"
		[AllDates]="AllDates"
		[StartDate]="StartDate"
		[EndDate]="EndDate"
		(BlockListSelected)="onBlockListSelected($event)"
	></caass-station-block-alert-table>
</div>

<!--Assignment Table-->
<div>
	<caass-station-block-alert-assignment-table [SelectedStationBlockAlert]="SelectedStationBlockAlert"></caass-station-block-alert-assignment-table>
</div>
